module.exports = __webpack_public_path__ + "static/media/salad.2cf6ca82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GetDish/salad.jpg
// module id = 338
// module chunks = 0